var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-body"},[_c('div',{staticClass:"content-main"},[_c('div',{staticClass:"content-header"},[_c('h3',[_vm._v("My Wallet")])]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"list"},[_vm._v(".....")])])])])
}]

export { render, staticRenderFns }